/**
 * App — root component with routing and dark mode support.
 */
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Header } from './components/Header';
import HomePage from './pages/HomePage';
import ClassicPage from './pages/ClassicPage';
import CustomCreatePage from './pages/CustomCreatePage';
import CustomPlayPage from './pages/CustomPlayPage';
import { loadDictionary } from './store/slices/dictionarySlice';

const App = () => {
  const dispatch = useDispatch();
  const darkMode = useSelector((state) => state.app.darkMode);
  const theme = useSelector((state) => state.app.theme);

  // Load dictionary on app mount
  useEffect(() => {
    dispatch(loadDictionary());
  }, [dispatch]);

  // Apply dark mode class to html element
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  // Apply theme class to html element
  useEffect(() => {
    // Remove all theme classes first
    const themeClasses = ['theme-japanese', 'theme-penguin'];
    document.documentElement.classList.remove(...themeClasses);
    
    if (theme !== 'default') {
      document.documentElement.classList.add(`theme-${theme}`);
    }
  }, [theme]);

  // Use basename for subpath deployment
  return (
    <Router basename={window.location.pathname.startsWith('/os-wordle') ? '/os-wordle' : '/'}>
      <div className={`min-h-screen flex flex-col text-gray-900 dark:text-gray-100 transition-colors duration-300`}>
        <Header />
        <main className="flex-1 flex flex-col max-w-lg mx-auto w-full">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/classic" element={<ClassicPage />} />
            <Route path="/custom" element={<CustomCreatePage />} />
            <Route path="/play/:gameCode" element={<CustomPlayPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
};

export default App;
